module.exports = __webpack_public_path__ + "static/media/18.08.2020_mail.pdf";